"use client";

import { cn } from "@v1/ui/utils";
import type { ReactElement, ReactNode, RefObject } from "react";
import { createPortal } from "react-dom";
import {
  PUBLIC_BOOKING_FLOATING_PANEL_CLASS,
  type PublicBookingFloatingPanelPos,
} from "./public-booking-floating-panel";

/** Fixed panel on `document.body` — opaque, never clipped by the booking card. */
export function PublicBookingFloatingPanelPortal({
  open,
  pos,
  panelRef,
  className,
  children,
}: {
  readonly open: boolean;
  readonly pos: PublicBookingFloatingPanelPos | null;
  readonly panelRef: RefObject<HTMLDivElement | null>;
  readonly className?: string;
  readonly children: ReactNode;
}): ReactElement | null {
  if (!open || !pos || typeof document === "undefined") return null;

  return createPortal(
    <div
      ref={panelRef}
      data-booking-overlay
      style={{
        position: "fixed",
        left: pos.left,
        width: pos.width,
        maxHeight: pos.maxHeight,
        ...(pos.openUp ? { bottom: pos.bottom } : { top: pos.top }),
      }}
      className={cn(PUBLIC_BOOKING_FLOATING_PANEL_CLASS, className)}
    >
      {children}
    </div>,
    document.body,
  );
}
